"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styles_1 = require("@mui/material/styles");
const Typography_1 = __importDefault(require("@mui/material/Typography"));
const SectionTitle = (0, styles_1.styled)(Typography_1.default)(({ theme }) => ({
    marginBottom: theme.spacing(2),
    marginLeft: theme.spacing(2),
}));
function Section(props) {
    const { title, children, className } = props;
    return (react_1.default.createElement("div", { className: className },
        react_1.default.createElement(SectionTitle, { variant: "subtitle1" }, title),
        children));
}
exports.default = Section;
